import { FiSend } from "react-icons/fi";
import { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
    message: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {
      name: !formData.name.trim(),
      email: !formData.email.trim(),
      message: !formData.message.trim(),
    };
    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      e.target.submit();
    }
  };

  return (
    <div
      name="contact"
      className="w-full h-full bg-gradient-to-b from-black to-gray-800 p-4 text-white "
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Let us talk👇🚀
          </p>
          <p className="py-6">
            I am always open to new opportunities, collaborations, and exciting
            projects. Whether you are looking to build a web application, a
            mobile app, or simply want to connect and share ideas, feel free to
            reach out. Let us create something amazing together!
          </p>
        </div>
        <div className="flex justify-center items-center">
          <form
            method="POST"
            action="https://getform.io/f/55c19385-c535-4cbe-8f02-7249b230ad17"
            className="flex flex-col w-full md:w-1/2"
            onSubmit={handleSubmit}
          >
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className={`p-2 bg-transparent border-2 rounded-md text-white focus:outline-none ${
                errors.name ? "border-red-500" : "border-white"
              }`}
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <p className="text-red-500">Name is required</p>}

            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              className={`my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none ${
                errors.email ? "border-red-500" : "border-white"
              }`}
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p className="text-red-500">Email is required</p>}

            <textarea
              name="message"
              rows="10"
              placeholder="Enter your message ..."
              className={`p-2 bg-transparent border-2 rounded-md text-white focus:outline-none ${
                errors.message ? "border-red-500" : "border-white"
              }`}
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            {errors.message && (
              <p className="text-red-500">Message is required</p>
            )}

            <button
              type="submit"
              className="group text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300"
            >
              Send{" "}
              <FiSend className="ml-2 group-hover:rotate-[-50deg] duration-300" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
